import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

// 出勤の申告の設定(その店舗の個別)。adminのみ
export default {
  getCheckInSettings() {
    return axiosIns.get('/admin/check_in_settings')
  },
  updateRule(rule) {
    return axiosIns.put('/admin/check_in_settings/rule', snakecaseKeys({ rule }))
  },
  // グループの設定に戻す
  inheritRule() {
    return axiosIns.delete('/admin/check_in_settings/rule')
  },
  // グループの項目を複製して、この店舗だけの項目にする
  customizeItems() {
    return axiosIns.post('/admin/check_in_settings/items/customize')
  },
  inheritItems() {
    return axiosIns.delete('/admin/check_in_settings/items/customize')
  },
  createItem(item) {
    return axiosIns.post('/admin/check_in_settings/items', snakecaseKeys({ item }))
  },
  updateItem(id, item) {
    return axiosIns.patch(`/admin/check_in_settings/items/${id}`, snakecaseKeys({ item }))
  },
  deleteItem(id) {
    return axiosIns.delete(`/admin/check_in_settings/items/${id}`)
  },
  reorderItems(ids) {
    return axiosIns.patch('/admin/check_in_settings/items/reorder', { ids })
  },
  preview({ rule, items }) {
    return axiosIns.post('/admin/check_in_settings/preview', snakecaseKeys({ rule, items }))
  },
}
